import React from 'react';
import { ChevronLeft } from 'lucide-react';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-slate-950 dark:via-slate-950 dark:to-slate-950 flex justify-center py-8">
            <div className="w-full max-w-3xl px-4 lg:px-8">
                <button
                    onClick={() => window.location.hash = '/'}
                    className="inline-flex items-center text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 font-medium mb-8 transition-colors"
                >
                    <ChevronLeft size={18} className="mr-1" />
                    Back to Home
                </button>

                <article className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 border border-gray-200 dark:border-slate-800">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Terms of Service</h1>

                    <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-slate-300 space-y-4">
                        <p>Last updated: {new Date().toLocaleDateString()}</p>

                        <p>
                            These Terms of Service ("Terms") govern your use of the BrieflyCA website
                            and mobile application ("Service"). By accessing or using the Service,
                            you agree to be bound by these Terms. If you do not agree, you may not use the Service.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            1. Use of the Service
                        </h2>
                        <p>
                            BrieflyCA provides rewritten Canadian news summaries for informational purposes.
                            You agree to use the Service lawfully and not for any prohibited activity,
                            including attempting to disrupt or reverse engineer the platform.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            2. Content & Accuracy
                        </h2>
                        <p>
                            While we strive to ensure the accuracy of our rewritten news summaries,
                            we do not guarantee completeness, reliability, or timeliness.
                            BrieflyCA is not responsible for errors, omissions, or decisions made
                            based on the content provided.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            3. Intellectual Property
                        </h2>
                        <p>
                            All original content, summaries, UI design, branding, and features within the Service
                            are the exclusive property of BrieflyCA. You may not copy, reproduce, distribute,
                            or create derivative works without written permission.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            4. User Data & Privacy
                        </h2>
                        <p>
                            Your use of the Service is also governed by our
                            {" "}
                            <a href="#/privacy" className="text-blue-600 dark:text-blue-400 hover:underline">
                                Privacy Policy
                            </a>.
                            We collect minimal information and do not sell personal data.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            5. Third-Party Links
                        </h2>
                        <p>
                            The Service may include links to third-party websites or news sources.
                            We have no control over these sites and are not responsible for their content,
                            policies, or actions. You access them at your own risk.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            6. Push Notifications
                        </h2>
                        <p>
                            If enabled, BrieflyCA may send category-based push notifications.
                            You may disable notifications at any time through your device settings or in the app.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            7. Advertisements
                        </h2>
                        <p>
                            BrieflyCA may display non-intrusive banner advertisements, including internal promotions
                            (e.g., AutoLog, ASK Studios). Ads are not personalized, and no personal data is shared
                            with advertisers.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            8. Service Availability
                        </h2>
                        <p>
                            We aim to keep BrieflyCA available at all times, but uptime is not guaranteed.
                            We may suspend or modify the Service without notice for maintenance or improvements.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            9. Limitation of Liability
                        </h2>
                        <p>
                            To the fullest extent permitted by law, BrieflyCA is not liable for any damages arising
                            from your use or inability to use the Service, including reliance on news summaries
                            or third-party content.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            10. Termination
                        </h2>
                        <p>
                            We reserve the right to suspend or terminate access to the Service at our discretion,
                            without prior notice, if Terms are violated or misuse is detected.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            11. Changes to These Terms
                        </h2>
                        <p>
                            We may update these Terms periodically. Continued use of the Service after changes
                            indicates acceptance of the updated Terms.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            12. Contact Us
                        </h2>
                        <p>
                            For questions or concerns regarding these Terms, contact us at:
                        </p>
                        <p>
                            📧 <strong>info@askstudios.ca</strong><br />
                            🌐 <strong>https://brieflyca.vercel.app</strong>
                        </p>
                    </div>
                </article>
            </div>
        </div>
    );
};

export default TermsOfService;
